import { Navigate } from 'react-router-dom';
import { useAuth } from '@Contexts/auth';
import { Loader } from 'lucide-react';

const ProtectedRoute = ({
  roles = [],
  permissions = [],
  checkEveryRole = false,
  checkEveryPermission = false,
  children,
}) => {
  // return children;

  const { checkAccess, userAccessReady } = useAuth();

  if (!userAccessReady) {
    return <Loader />;
  }

  if (!checkAccess(roles, permissions, checkEveryRole, checkEveryPermission)) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
};

export default ProtectedRoute;
